import { render, staticRenderFns } from "./AssignManagerRequiredModal.vue?vue&type=template&id=0f0a423e"
import script from "./AssignManagerRequiredModal.vue?vue&type=script&lang=js"
export * from "./AssignManagerRequiredModal.vue?vue&type=script&lang=js"
import style0 from "./AssignManagerRequiredModal.vue?vue&type=style&index=0&id=0f0a423e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports